<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Для оплаты услуг связи войдите в кошелек ImPay</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="fon-input">
            <input type="text" readonly class="input-field" v-model="maskedPhone">
            <img @click="clickBsKey" class="bnt-key-bs" src="/imgs/btn_bs_1.png">
          </div>
        </td>
      </tr>
      <tr>
        <td class="td-row" width="30%">
          <div class="input-info-block">
            <div class="info-text">Регистрируя кошелек ImPay, вы соглашаетесь с условиями сервиса ImPay</div>
            <div style="margin-top: 20px"><img @click="ofertClick" src="/imgs/btn_information_1.png"></div>
          </div>
        </td>
        <td class="td-row" width="40%" align="center">
          <KeyboardDigital :on-click="onClickKey"></KeyboardDigital>
        </td>
        <td width="30%">
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="exitClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" ref="btnFwd" src="/imgs/fwd_1.png">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
    <SessionTimeout v-show="sessionTimeoutShow" :visible="sessionTimeoutShow" :on-close="onSessionClose"></SessionTimeout>
    <OfertConfirm v-show="showOfertConfirm" :on-close="onOfertClose"></OfertConfirm>
  </div>
</template>

<script>
import KeyboardDigital from "@/components/KeyboardDigital.vue";
import LoaderWait from "@/components/LoaderWait.vue";
import { formatMask } from "@/utils/format_mask.js";
import MessageBox from "@/components/MessageBox.vue";
import SessionTimeout from "@/components/SessionTimeout.vue";
import OfertConfirm from "@/components/OfertConfirm.vue";

export default {
  name: 'LoginPage',
  components: {OfertConfirm, SessionTimeout, MessageBox, LoaderWait, KeyboardDigital},
  data () {
    return {
      loading: false,
      timer: null,
      phone: '',
      maskedPhone: '+7             ',
      showMessage: false,
      errorMessage: '',
      sessionTimeoutShow: false,
      showOfertConfirm: false,
    }
  },
  mounted() {
    this.updateTimer()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.exitClick(), 60000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    onClickKey(key) {
      this.updateTimer()
      const maxLength = 10;
      if (this.phone.length < maxLength) {
        this.phone = this.phone + key
        this.maskedPhone = formatMask(this.phone, '+7 (###) ###-##-##')
      }
    },
    clickBsKey() {
      this.updateTimer()
      if (this.phone.length > 0) {
        this.phone = this.phone.substring(0, this.phone.length - 1)
        this.maskedPhone = formatMask(this.phone, '+7 (###) ###-##-##')
      }
    },
    exitClick() {
      this.stopTimer()
      this.$store.dispatch('AUTH_LOGOUT')
    },
    fwdClick() {
      if (this.loading) {
        return false;
      }
      if (!this.checkPhone()) {
        this.updateTimer()
        this.messageShow('Проверьте правильность номера телефона')
        return false;
      }

      this.stopTimer()
      this.loading = true

      this.$store.dispatch('AUTH_CHECK_REQUEST', {
        phone: this.phone,
      }).then((res) => {
        this.loading = false
        if (res.status == 1) {
          if (res.data.status == 0) {
            this.ofertConfirmShow()
          } else {
            this.$router.push('password')
          }
        } else {
          this.updateTimer()
          this.messageShow('Проверьте правильность номера телефона')
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    ofertClick() {
      this.stopTimer()
      this.$router.push('ofert')
    },
    checkPhone() {
      const maxLength = 10;
      return this.phone.length >= maxLength
    },
    messageShow(message) {
      this.stopTimer()
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
      this.updateTimer()
    },
    showSessionEnd() {
      this.sessionTimeoutShow = true
    },
    onSessionClose(isContinue = false) {
      this.sessionTimeoutShow = false
      if (!isContinue) {
        this.exitClick()
      } else {
        this.updateTimer()
      }
    },
    ofertConfirmShow() {
      this.stopTimer()
      this.showOfertConfirm = true;
    },
    onOfertClose(result) {
      console.log(result);
      this.showOfertConfirm = false;
      if (result) {
        this.$router.push('password')
      } else {
        this.updateTimer()
      }
    },
  }
}
</script>

<style scoped>

</style>
